"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleAssessmentsPerformanceService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("../base.service");
var api_constants_1 = require("../../constants/api.constants");
var models_1 = require("../../models");
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var MultipleAssessmentsPerformanceService = /** @class */ (function (_super) {
    __extends(MultipleAssessmentsPerformanceService, _super);
    function MultipleAssessmentsPerformanceService(options, wwMultipleAssessmentsCompileClient) {
        var _this = _super.call(this, options) || this;
        _this.wwMultipleAssessmentsCompileClient = wwMultipleAssessmentsCompileClient;
        return _this;
    }
    MultipleAssessmentsPerformanceService.newInstance = function (options) {
        var clientOptions = {
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        };
        var retryOptions = options.retryOptionsOnNonAuthorized;
        return new MultipleAssessmentsPerformanceService(options, insync_assess_sdk_1.WWMultipleAssessmentsCompileClient.newInstance(clientOptions, retryOptions));
    };
    /**
     * Retrieves the average score by template.
     * @param {string[]}     classes         - classes ids
     * @param {AssessmentTemplate[]}     templates         - assessment templates
     */
    MultipleAssessmentsPerformanceService.prototype.getAverageScoreByTemplate = function (classes, templates) {
        return __awaiter(this, void 0, void 0, function () {
            var templatesIds, averageScoreDtos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templatesIds = templates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.wwMultipleAssessmentsCompileClient.findAveragePercentageScorePerTemplate(classes, templatesIds, this.getDefaultHeaders())];
                    case 1:
                        averageScoreDtos = _a.sent();
                        return [2 /*return*/, templates.map(function (template) {
                                var dto = averageScoreDtos.find(function (_a) {
                                    var assessmentTemplateId = _a.assessmentTemplateId;
                                    return assessmentTemplateId === template.id;
                                });
                                return new models_1.AssessmentPerformanceWW({
                                    assessmentTemplate: template,
                                    percentage: !(0, isUndefined_1.default)(dto) ? dto.averagePercentage : 0,
                                });
                            })];
                }
            });
        });
    };
    /**
     * Retrieves the average minutes by template.
     * @param {string[]}                 classes         - classes ids
     * @param {AssessmentTemplate[]}     templates       - assessment templates
     */
    MultipleAssessmentsPerformanceService.prototype.getAverageMinutesByTemplate = function (classes, templates) {
        return __awaiter(this, void 0, void 0, function () {
            var templatesIds, averageMinutesDtos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templatesIds = templates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.wwMultipleAssessmentsCompileClient.findAverageDurationPerTemplate(classes, templatesIds, this.getDefaultHeaders())];
                    case 1:
                        averageMinutesDtos = _a.sent();
                        return [2 /*return*/, templates.map(function (template) {
                                var dto = averageMinutesDtos.find(function (_a) {
                                    var assessmentTemplateId = _a.assessmentTemplateId;
                                    return assessmentTemplateId === template.id;
                                });
                                return new models_1.AssessmentPerformanceWW({
                                    assessmentTemplate: template,
                                    averageTimeSpent: !(0, isUndefined_1.default)(dto) ? dto.averageTimeSpent : 0,
                                });
                            })];
                }
            });
        });
    };
    /**
     * Retrieves the assignees assessment performances performances by class and templates.
     * @param section                - class
     * @param assessmentTemplates    - assessment templates list
     */
    MultipleAssessmentsPerformanceService.prototype.getAssigneesAssessmentPerformancesByClass = function (section, assessmentTemplates, students) {
        return __awaiter(this, void 0, void 0, function () {
            var templatesIds, studentDetailsDtos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templatesIds = assessmentTemplates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.wwMultipleAssessmentsCompileClient.findAssigneeDetailPerTemplate(section.id, templatesIds, this.getDefaultHeaders())];
                    case 1:
                        studentDetailsDtos = _a.sent();
                        return [2 /*return*/, this.buildAssigneeAssessmentPerformance(students, studentDetailsDtos, assessmentTemplates)];
                }
            });
        });
    };
    /**
     * Converts a list AssigneeAssessmentPerformanceDto to Assignee Assessmet Performance for WW
     * @param itemQuestionsPerformanceDto[]
     * @param questions[]
     */
    MultipleAssessmentsPerformanceService.prototype.buildAssigneeAssessmentPerformance = function (students, assigneeAssessmentPerformanceDto, assessmentTemplates) {
        var _this = this;
        return students.map(function (student) {
            var assigneePerformance = assigneeAssessmentPerformanceDto.find(function (_a) {
                var assigneeId = _a.assigneeId;
                return assigneeId === student.id;
            });
            var assessmentTemplatePerformances = assessmentTemplates.map(function (assessment) {
                var assessmentPerformance = assigneePerformance === null || assigneePerformance === void 0 ? void 0 : assigneePerformance.assessmentTemplates.find(function (_a) {
                    var assessmentTemplateId = _a.assessmentTemplateId;
                    return assessment.id === assessmentTemplateId;
                });
                var _a = assessmentPerformance || {}, _b = _a.score, score = _b === void 0 ? 0 : _b, _c = _a.maxScore, maxScore = _c === void 0 ? 0 : _c, _d = _a.percentage, percentage = _d === void 0 ? 0 : _d;
                return new models_1.AssessmentPerformanceWW({
                    assessmentTemplate: assessment,
                    score: score,
                    maxScore: maxScore,
                    percentage: percentage,
                    assessmentTemplateMaxScore: maxScore,
                });
            });
            var averagePerformance = _this.calculateAverageAssessmentPerformance(assessmentTemplatePerformances);
            var averageScore = _this.calculateAverageScore(assessmentTemplatePerformances);
            var averageMaxScore = _this.calculateAverageAssessmentMaxScore(assessmentTemplatePerformances);
            return new models_1.AssigneeAssessmentPerformance({
                assigneeId: student.id,
                averagePerformance: averagePerformance,
                averageScore: averageScore,
                averageMaxScore: averageMaxScore,
                assessmentPerformances: assessmentTemplatePerformances,
            });
        });
    };
    /**
     * Retrieves the overall of assignee assessment performances.
     * @param {AssessmentTemplate[]}                assessmentTemplates    - assessment template list
     * @param {AssigneeAssessmentPerformance[]}     assigneesPerformances  - List of assignees assessment performances
     */
    MultipleAssessmentsPerformanceService.prototype.getOverallAssigneeAssessmentPerformances = function (assessmentTemplates, assigneesPerformances) {
        var _this = this;
        var overallPerformance = assigneesPerformances.reduce(function (total, assignee) { return total + assignee.averagePerformance; }, 0) /
            assigneesPerformances.length;
        var overallAssessmentTemplatePerformances = assessmentTemplates.map(function (template) {
            var assessementPerformanceData = [];
            assigneesPerformances.forEach(function (assignee) {
                var assessment = assignee.assessmentPerformances.find(function (_a) {
                    var assessmentTemplate = _a.assessmentTemplate;
                    return assessmentTemplate.id === template.id;
                });
                if (assessment) {
                    assessementPerformanceData.push(assessment);
                }
            });
            var overallAssessmentScore = _this.calculateAverageScore(assessementPerformanceData);
            var overallAssessmentMaxScore = _this.calculateAverageAssessmentMaxScore(assessementPerformanceData);
            return new models_1.AssessmentPerformanceWW({
                assessmentTemplate: template,
                score: overallAssessmentScore,
                maxScore: overallAssessmentMaxScore,
                assessmentTemplateMaxScore: overallAssessmentMaxScore,
                percentage: _this.calculatePercentage(overallAssessmentScore, overallAssessmentMaxScore),
            });
        });
        var overallScore = this.calculateAverageScore(overallAssessmentTemplatePerformances);
        var overallMaxScore = this.calculateAverageAssessmentMaxScore(overallAssessmentTemplatePerformances);
        return new models_1.AssigneeAssessmentPerformance({
            averagePerformance: overallPerformance,
            averageMaxScore: overallMaxScore,
            averageScore: overallScore,
            assessmentPerformances: overallAssessmentTemplatePerformances,
        });
    };
    MultipleAssessmentsPerformanceService.prototype.calculateAverageScore = function (assessmentPerformance) {
        return (assessmentPerformance.reduce(function (total, assessment) { return total + assessment.score; }, 0) /
            assessmentPerformance.length);
    };
    /**
     * Returns the percentage based on the provided data, if maxScore is 0 it returns 0
     * @param score
     * @param maxScore
     */
    MultipleAssessmentsPerformanceService.prototype.calculatePercentage = function (score, maxScore) {
        if (score === void 0) { score = 0; }
        if (maxScore === void 0) { maxScore = 0; }
        return maxScore ? (score / maxScore) * 100 : 0;
    };
    MultipleAssessmentsPerformanceService.prototype.calculateAverageAssessmentPerformance = function (assessmentPerformance) {
        return (assessmentPerformance.reduce(function (total, assessment) { return total + assessment.percentage; }, 0) /
            assessmentPerformance.length);
    };
    MultipleAssessmentsPerformanceService.prototype.calculateAverageAssessmentMaxScore = function (assessmentPerformance) {
        return (assessmentPerformance.reduce(function (total, assessment) { return total + assessment.assessmentTemplateMaxScore; }, 0) / assessmentPerformance.length);
    };
    return MultipleAssessmentsPerformanceService;
}(base_service_1.BaseService));
exports.MultipleAssessmentsPerformanceService = MultipleAssessmentsPerformanceService;
